import discardEventOption from './actions/discardEventOption';
import saveEventOption from './orchestration/saveEventOption';
import EventFull from './components/EventFull';
import isEventOptionDirty from './utils/isEventOptionDirty';
import * as React from 'react';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
var EventOption = {
    key: 'event',
    titleStringKey: 'optionTitle_event',
    searchTermsStringKey: 'optionSearch_event',
    fullOptionFormSettings: {
        render: function () { return React.createElement(EventFull, null); },
        isDirty: isEventOptionDirty,
        onSave: saveEventOption,
        onDiscard: discardEventOption,
    },
    isHidden: function () { return !isControlFeatureEnabled('cal-event-invitation-setting'); },
};
export default EventOption;
//# sourceMappingURL=EventOption.js.map